module.exports = __webpack_public_path__ + "img/gzh.ef7dd6eb.png";